// Static data for Customize Product Section - Artwork Method Selection Buttons
// These buttons allow users to choose HOW they want to provide their artwork
// (not to be confused with imprint methods like Screenprint, Embroidery, etc.)
import { useAppStore } from '../stores/useAppStore.js';
export const ARTWORK_METHODS = [
  {
    id: 'new',
    label: 'Start New Imprint',
    iconName: 'IconNewImprint', // Reference to icon component
    description: 'Choose imprint type, location, and add your custom message or artwork.',
    isDefault: true // Selected by default
  },
  {
    id: 'send',
    label: 'Send Us Your Artwork',
    iconName: 'IconSendArtwork',
    description: 'Email your artwork files to artwork@comda.com with your Order Number in the subject line.',
    email: 'artwork@comda.com',
    isDefault: false
  },
  {
    id: 'previous',
    label: 'Use My Previous Artwork',
    iconName: 'IconPreviousArtwork',
    description: 'Select from your previously uploaded artwork files.',
    requiresAuth: true, // User must be logged in
    isDefault: false
  },
  {
    id: 'design',
    label: 'Design Online',
    iconName: 'IconDesignOnline',
    description: 'Use our online design tool to create your custom imprint.',
    isDefault: false
  }
];

// Instructional text displayed above the artwork method buttons
export const ARTWORK_INSTRUCTION_TEXT = `
You can choose to start a new imprint, or if you are a returning customer you can select “Use My Previous Artwork” - we keep your previous files on record. If you would like to make any changes to a previous imprint please comment any specifics in the “Special Instructions” box.
`;

// Email for sending artwork
export function getArtworkInstructionTextAdditional() {
  const appStore = useAppStore();

  const email = !appStore.isComda
      ? 'mlcs@mapleleafpromotions.com'
      : 'artwork@comda.com';
  return `
Alternatively, if you would like to send your art files after placing your order, select “Send Us Your Artwork After Ordering”. After placing your order, send an email to <a href="mailto:${email}">${email}</a> with your art files attached and Order Number in the subject line. Please provide artwork promptly so that our team can create a Digital Proof prior to production.
`;
}


